import React from 'react';
import { styled } from '@mui/material/styles';
import { getStaffSelectOptions } from '../../utils/getStaffSelectOptions';
import { StaffData } from '../../types/staffData';

type Option = {
  id: number;
  name: string;
};
type TProps = {
  value: number;
  setValue: (value: number) => void;
  options: Option[];
  width: string;
  initialUserData?: StaffData | null;
};

export const SelectPullDown: React.FC<TProps> = ({
  value,
  setValue,
  options,
  width,
  initialUserData = null
}) => {
  return (
    <InputContainerSelectBox width={width}>
      <SelectBoxStyle
        value={value}
        onChange={text => {
          setValue(parseInt(text.target.value));
        }}
        form='carform'
      >
        <option value={0}>選択してください</option>
        {getStaffSelectOptions(options, initialUserData)}
      </SelectBoxStyle>
    </InputContainerSelectBox>
  );
};

const InputContainerSelectBox = styled('div')(
  ({ width }: { width: string }) => ({
    marginLeft: 10,
    marginRight: 13,
    width: width
  })
);

const SelectBoxStyle = styled('select')({
  WebkitAppearance: 'menulist-button',
  backgroundColor: 'white',
  borderColor: '#c1c1c1',
  height: 48,
  width: '100%'
});
